// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

export interface FedExPickUpAddress {
  line: Array<string>;
  city: string;
  state: string;
  postalCode: string;
  country: string;
}

export type FedExDropLocation = "FRONT" | "REAR" | "SIDE" | "NONE";

export interface FedExShipperDetails {
  name: string;
  phone: string;
}

export interface FedExShippingDetails {
  address: FedExPickUpAddress;
  remarks: string;
}

export interface FedExPickupTime {
  date: string;
  startTime: string;
  endTime: string;
}

export interface FedExPickupDetails extends FedExPickupTime {
  packageLocation: FedExDropLocation;
  trackingNumber?: string;
}

export interface ProposedFedExPickupTime extends FedExPickupTime {
  humanDate: string;
  humanTime: string;
}

export interface FedExConfirmation {
  pickupWindow: ProposedFedExPickupTime;
  confirmation: string;
}

export interface FedExConfirmationDetails {
  address: FedExPickUpAddress;
  packageLocation: FedExDropLocation;
  remarks: string;
}

export enum FedExError {
  NO_SERVICE,
  SCHEDULE_PICKUP_FAILED,
  NETWORK_ERROR,
}
